module.exports = __webpack_public_path__ + "img/daNang2.be97af42.jpg";